import { useContext, useEffect } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import Layout from './Layout';
import { addUserSpecificDomains, getDomainElementsForGivenYearRange } from '../../../library/Service/domainService';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import moment from 'moment';

const BasAdminReport = () => {
    const { globalState } = useContext(GlobalContext);

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);

    useEffect(() => {
        // filter DOmain dynamic data 
        if (data?.filterDomains && typeof data.filterDomains === 'object') {
            applyFilterDomains({ filterDomains: data.filterDomains, formConfig, domain });
        }
        //set only K12_school
        const instituteTypes = domain.get('INSTITUTE_DOMAIN');
        console.log("instituteTypes",instituteTypes)
        if (instituteTypes) {
            const allowedTypes = ['PRE_SCHOOL', 'SCHOOL', 'K12_SCHOOL'];
           const filteredK12Institutes = instituteTypes.filter((institute) => {
                try {
                    const flexCol = institute.flexCol;
                    if (!flexCol) return false;
                    const parsed = JSON.parse(flexCol);
                    return allowedTypes.includes(parsed?.institute_type);
                } catch (e) {
                    return false;
                }
            });
            domain.set('K12_SCHOOL', filteredK12Institutes);
        }

        // const programLevels = domain.get('ALL_PROGRAM_CODE');
        // if (programLevels) {
        //     const allowedProgramCodes = ['8', '9', '10', '11', '12'];

        //     const filteredK12Programs = programLevels.filter(program =>
        //         allowedProgramCodes.includes(String(program.code))
        //     );

        //     domain.set('K12_PROGRAM', filteredK12Programs);
        // }

        const currentYear = moment().year();
        const startYear = currentYear + 1;
        const endYear = startYear + 5; // next 10 years

        const pastYearCodeList = getDomainElementsForGivenYearRange('PAST_YEAR_CODE', startYear, endYear)
        domain.set('PAST_YEAR_CODE', pastYearCodeList);

        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, internal, routeInfo },
        });
    }, []);

    function applyFilterDomains({
        filterDomains,
        formConfig,
        domain,
        }: {
        filterDomains: Record<string, any[]>;
        formConfig: any;
        domain: Map<string, any[]>;
        }) {
        const allFormItems =
            formConfig?.sectionRepository?.flatMap((section:any) => section.controlGroup || []) || [];

        Object.entries(filterDomains).forEach(([key, filterValue]) => {
            if (!Array.isArray(filterValue)) {
            console.warn(`Skipping domain key "${key}" as its value is not an array:`, filterValue);
            return;
            }

            const formItem = allFormItems.find((item:any) => item?.props?.domainCategoryCode === key);

            if (!formItem) {
            console.warn(`No form item found with domainCategoryCode: ${key}`);
            domain.set(key, filterValue); // fallback set with key
            return;
            }

            const domainCategoryCode = formItem.props.domainCategoryCode;
            const shouldMapFromCountryCode = ['STUDENT_COUNTRY_CODE', 'COUNSELLOR_COUNTRY_CODE','PARENT_COUNTRY_CODE'].includes(domainCategoryCode);
            const shouldMapFromFieldOfStudyCode = ['COUNSELLOR_FIELD_OF_STUDY_TYPE_CODE_ALUMNI', 'STUDENT_FIELD_OF_STUDY_TYPE_CODE_ALUMNI','PARENT_FIELD_OF_STUDY_TYPE_CODE'].includes(domainCategoryCode);
            const shouldMapFromCollegeCode = ['COUNSELLOR_UNIVERSITY_CODE', 'STUDENT_UNIVERSITY_CODE','PARENT_UNIVERSITY_CODE'].includes(domainCategoryCode);

            let baseDomain;

            if (shouldMapFromCountryCode) {
                baseDomain = domain.get('COUNTRY_CODE');
            } else if (shouldMapFromFieldOfStudyCode) {
                baseDomain = domain.get('FIELD_OF_STUDY_TYPE_CODE_ALUMNI');
            } else if(shouldMapFromCollegeCode){
                baseDomain = domain.get('UNIVERSITY_CODE');
            }else{
                baseDomain = domain.get(domainCategoryCode);
            }

            if (!Array.isArray(baseDomain)) {
            console.warn(`Base domain not found for: ${domainCategoryCode}. Using raw values.`);
            domain.set(domainCategoryCode, filterValue);
            return;
            }

            const isCodeArray = typeof filterValue[0] === 'string' || typeof filterValue[0] === 'number';
            const filtered = isCodeArray
            ? baseDomain.filter(item => filterValue.includes(String(item.code)))
            : filterValue;

            // Add NOT_FILLED and NOT_SURE for specific domain categories
            if (['STUDENT_COUNTRY_CODE', 'COUNSELLOR_COUNTRY_CODE', 'COUNSELLOR_FIELD_OF_STUDY_TYPE_CODE_ALUMNI', 'STUDENT_FIELD_OF_STUDY_TYPE_CODE_ALUMNI','STUDENT_UNIVERSITY_CODE','COUNSELLOR_UNIVERSITY_CODE','PARENT_COUNTRY_CODE','PARENT_FIELD_OF_STUDY_TYPE_CODE','PARENT_UNIVERSITY_CODE'].includes(domainCategoryCode)) {
            filtered.unshift(
                { code: 'NOT_FILLED', value: 'Not Filled' },
                { code: 'NOT_SURE', value: 'Not Sure' }
            );
            }

            domain.set(domainCategoryCode, filtered);

        });
    }


    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <DebugBarControl />
            {!state.flags.isDataLoading && <Layout />}
        </SmartContext.Provider>
    );
};

export default BasAdminReport;
